import React, { useState, useEffect } from 'react';
import { FaClipboardList, FaCheckCircle, FaClock } from 'react-icons/fa';
import { getApiEndpoint } from '../../../config/api';
import './StaffDashboard.css';

export default function MyInspections() {
  const [inspections, setInspections] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInspections = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const url = filter === 'all'
          ? getApiEndpoint('/api/staff/inspections')
          : getApiEndpoint(`/api/staff/inspections?status=${filter}`);
        const res = await fetch(url, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        setInspections(data.inspections || []);
      } catch (err) {
        setInspections([]);
      }
      setLoading(false);
    };
    fetchInspections();
  }, [filter]);

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <div className="task-controls">
        <div className="filter-controls">
          <label>Status:</label>
          <select value={filter} onChange={e => setFilter(e.target.value)}>
            <option value="all">All</option>
            <option value="scheduled">Scheduled</option>
            <option value="in_progress">In Progress</option>
            <option value="completed">Completed</option>
            <option value="overdue">Overdue</option>
          </select>
        </div>
      </div>
      <div className="inspections-list">
        {inspections.map(inspection => (
          <div className="inspection-card" key={inspection.id}>
            <div className="inspection-header">
              <h4>{inspection.title}</h4>
              <span className={`status ${inspection.status}`}>{inspection.status.replace('_', ' ')}</span>
            </div>
            <div className="inspection-property">Property: {inspection.property_name}</div>
            <div className="inspection-date"><FaClock /> Date: {inspection.scheduled_date}</div>
            {inspection.status === 'completed' && <FaCheckCircle color="#27ae60" />}
          </div>
        ))}
      </div>
    </div>
  );
} 